// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("../assets/quest/first_mission_zoocamp_mark.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("../assets/quest/first_mission_greeting_leaf_left.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("../assets/quest/first_mission_greeting_leaf_right.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("../assets/quest/first_mission_greeting_zoocamp.svg", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_4___ = new URL("../assets/fonts/andong-katuri/Katuri.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_5___ = new URL("../assets/fonts/gosanja/GosanjaOTF.otf", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_6___ = new URL("../assets/fonts/pretendard/Pretendard-SemiBold.subset.woff2", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
var ___CSS_LOADER_URL_REPLACEMENT_5___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_5___);
var ___CSS_LOADER_URL_REPLACEMENT_6___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_6___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * 퀘스트 스팟 태블릿 스타일 — 가로 태블릿(landscape) 가정.
 * 주렁주렁 세계관: 숲/생명의 나무 → 그린 계열.
 * 모든 클래스는 .qt-page 하위로 스코프해 다른 화면과 충돌 방지.
 */

.qt-page {
  width: 100vw;
  height: 100vh;
  display: flex;
  flex-direction: column;
  background-color: #ecfdf5;
  background-image: url('https://pub-18639fa7483d49ba813c66ff73606a6f.r2.dev/cdn/mission/mission_spot_1280x800.webp');
  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  color: #064e3b;
  overflow: hidden;
}

@media (min-width: 1600px) {
  .qt-page {
    background-image: url('https://pub-18639fa7483d49ba813c66ff73606a6f.r2.dev/cdn/mission/mission_spot_1920x1200.webp');
  }
}

/* ── 헤더 ── */
.qt-page .qt-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 12px 20px;
  background: linear-gradient(135deg, rgba(5, 150, 105, 0.5) 0%, rgba(16, 185, 129, 0.5) 100%);
  color: #fff;
  flex-shrink: 0;
}

.qt-page .qt-btn-back {
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
}

.qt-page .qt-btn-back:active {
  background: rgba(255, 255, 255, 0.32);
}

.qt-page .qt-header-center {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  cursor: pointer;
}

.qt-page .qt-header-center h1 {
  margin: 0;
  font-size: 22px;
  font-weight: 800;
}

.qt-page .qt-header-title {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  max-width: calc(100vw - 260px);
}

.qt-page .qt-header-spot-trigger {
  appearance: none;
  box-sizing: border-box;
  height: 20px;
  min-height: 0;
  max-height: 20px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  max-width: 260px;
  border: 1px solid rgba(255, 255, 255, 0.7);
  border-radius: 8px;
  padding: 0 8px;
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
  font-size: 16px;
  font-weight: 800;
  line-height: 16px;
  cursor: pointer;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.qt-page .qt-header-spot-trigger:active {
  background: rgba(255, 255, 255, 0.32);
}

.qt-page .qt-header-spot-trigger:disabled {
  opacity: 0.62;
  cursor: default;
}

.qt-page .qt-header-spacer {
  width: 92px; /* btn-back 폭 대칭 → 타이틀 가운데 정렬 */
}

.qt-page .store-badge-inline {
  font-size: 13px;
  opacity: 0.92;
}

/* ── 본문 공통 ── */
.qt-page .qt-content {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 20px;
  overflow: auto;
}

/* ── 로딩/에러/세트없음 ── */
.qt-page .qt-center-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  text-align: center;
}

.qt-page .qt-center-icon {
  font-size: 72px;
}

.qt-page .qt-center-text {
  margin: 0;
  font-size: 26px;
  font-weight: 700;
}

.qt-page .qt-center-error .qt-center-text {
  color: #b91c1c;
}

.qt-page .qt-btn {
  border: none;
  border-radius: 12px;
  font-weight: 700;
  cursor: pointer;
}

.qt-page .qt-btn-retry {
  background: #059669;
  color: #fff;
  padding: 12px 28px;
  font-size: 18px;
}

.qt-page .qt-btn-retry:active {
  background: #047857;
}

/* ── 스팟 선택 ── */
.qt-page .qt-select-state {
  width: 100%;
  max-width: 1000px;
  display: flex;
  flex-direction: column;
  gap: 24px;
}

.qt-page .qt-select-head {
  text-align: center;
}

.qt-page .qt-select-title {
  margin: 0 0 6px;
  font-size: 28px;
  font-weight: 800;
}

.qt-page .qt-select-sub {
  margin: 0;
  font-size: 16px;
  color: #047857;
}

.qt-page .qt-spot-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 16px;
}

.qt-page .qt-spot-card {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding: 24px 20px;
  background: #fff;
  border: 2px solid #a7f3d0;
  border-radius: 16px;
  cursor: pointer;
  text-align: left;
  transition: transform 0.1s, border-color 0.1s, box-shadow 0.1s;
}

.qt-page .qt-spot-card:active {
  transform: scale(0.98);
  border-color: #059669;
  box-shadow: 0 4px 16px rgba(5, 150, 105, 0.25);
}

.qt-page .qt-spot-card-selected {
  background: #ecfdf5;
  border-color: #059669;
  box-shadow: 0 4px 16px rgba(5, 150, 105, 0.18);
}

.qt-page .qt-spot-name {
  font-size: 22px;
  font-weight: 800;
  color: #064e3b;
}

.qt-page .qt-spot-desc {
  font-size: 14px;
  color: #6b7280;
  line-height: 1.4;
}

.qt-page .qt-spot-card-foot {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  align-items: center;
  margin-top: 4px;
}

/* 스팟 카드 미션 배지(qr 이외) — 운영자가 스팟 종류를 한눈에 구분 */
.qt-page .qt-spot-mission {
  font-size: 13px;
  font-weight: 700;
  color: #047857;
  background: #d1fae5;
  border-radius: 999px;
  padding: 4px 12px;
}

.qt-page .qt-spot-current {
  font-size: 13px;
  font-weight: 800;
  color: #fff;
  background: #059669;
  border-radius: 999px;
  padding: 4px 12px;
}

/* ── 헤더 스팟 선택 팝업 ── */
.qt-page .qt-spot-modal-backdrop {
  position: fixed;
  inset: 0;
  z-index: 50;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 24px;
  background: rgba(6, 78, 59, 0.46);
}

.qt-page .qt-spot-modal {
  width: min(920px, 100%);
  max-height: calc(100vh - 48px);
  display: flex;
  flex-direction: column;
  gap: 18px;
  padding: 22px;
  background: #fff;
  border: 2px solid #a7f3d0;
  border-radius: 16px;
  box-shadow: 0 24px 64px rgba(6, 78, 59, 0.28);
}

.qt-page .qt-spot-modal-head {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 16px;
}

.qt-page .qt-spot-modal-title {
  margin: 0 0 4px;
  font-size: 26px;
  font-weight: 900;
  color: #064e3b;
}

.qt-page .qt-spot-modal-sub {
  margin: 0;
  font-size: 15px;
  font-weight: 700;
  color: #047857;
}

.qt-page .qt-spot-modal-close {
  border: none;
  border-radius: 10px;
  padding: 10px 16px;
  background: #e5e7eb;
  color: #374151;
  font-size: 15px;
  font-weight: 800;
  cursor: pointer;
}

.qt-page .qt-spot-modal-close:active {
  background: #d1d5db;
}

.qt-page .qt-spot-modal-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 14px;
  overflow: auto;
  padding: 2px;
}

/* ── 미션 수행 화면(ox/funny — 회원 식별 후) ── */
.qt-page .qt-mission-state {
  width: 100%;
  max-width: 860px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.qt-page .qt-mission-area {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 45vh;
}

/* ── 스캔 화면 ── */
.qt-page .qt-scan-state {
  width: 100%;
  max-width: 720px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
  transform: translateY(-24px);
}

.qt-page .qt-scanner-area {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  /* 카메라 미동작(HTTP·USB 리더기) 시에도 영역이 붕괴되지 않게 — 컬러 오버레이가
     항상 충분한 영역을 덮어 흰 글자가 밝은 페이지로 삐져나오지 않도록 한다. */
  min-height: 45vh;
  width: 100%;
  /* 어두운 스캔 박스 — 카메라 뷰파인더 + 흰색 "카메라 안됨" 안내/오버레이 가독성 확보
     (QRScanner dev-notice 가 흰색/소형이라 밝은 배경 위에선 안 보였음). */
  background: #0b2e22;
  border-radius: 16px;
  overflow: hidden;
}

@media (max-width: 1599px) {
  .qt-page .qt-scanner-area {
    width: 60%;
    min-width: 420px;
  }
}

/* 관리자 \`미션 선택\`의 첫 번째 항목 — 장식 배경 없이 검은 화면에서 QR 태깅 대기.
   첫 항목 판정은 QuestTagPage의 spots 배열 순서를 따르며, 이 클래스는 PHASE_SCAN에만 붙는다.
   태깅 후 OX/사진 수행 화면은 기존 전용 배경으로 돌아간다. */
.qt-page-first-mission {
  /* 🔴 스케일 변수는 **쓰는 자리와 같은 규칙 트리**에서 정의한다. 조상에만 두면
     \`calc(720 * var(--fm-u))\` 가 무효가 되어 요소가 브라우저 기본 크기로 쪼그라든다
     (2026-08-13 OX 오버레이에서 실제로 겪었고 CSS 원문 가드는 그때 통과했다). */
  --fm-scale: 1; /* 크기 조절 손잡이. 1 = Figma 원본 */
  --fm-u: calc(100vw / 1920 * var(--fm-scale)); /* Figma 1px */

  background-color: #000;
  background-image: none;
  color: #fff;
}

/* 첫 미션 대기 화면 로고 — Figma 3379:44765 \`3956:51800\`.
   🔴 **같은 노드 id 가 세 번 바뀌었다.** 2026-08-14 BASE CAMP 720x435 →
      2026-08-19 Z 마크 640x640(\`#189018\`) → 2026-08-20 **ZOO CAMP 마크 400x400**(\`#00A700\`).
      재적용 전 반드시 재취득한다 — 이 화면은 그 경고가 세 번 다 맞은 사례다.
   원본 프레임 1920x1200, 400x400 @ (760,256) → 가로만 중심(760+200=960), 세로는 top 고정.
   🔴 **배경은 그대로 검정이다.**
   🔴 가로 중앙정렬은 음수 마진으로 한다 — 이 저장소 관례다. transform 은 나중에 애니메이션이
      붙으면 덮여 좌상단 기준으로 밀린다(2026-07-31 실제 사고). */
.qt-page-first-mission .qt-first-mission-logo {
  position: absolute;
  left: 50%;
  top: calc(256 * var(--fm-u));
  width: calc(400 * var(--fm-u));
  height: calc(400 * var(--fm-u));
  margin-left: calc(-200 * var(--fm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_0___}) no-repeat center / contain;
  pointer-events: none;
}

/* 첫 미션 대기 화면 CTA 문구 2행 — Figma \`3939:50824\` / \`3951:51053\` (2026-08-20 신설).
   권위: docs/2026-08-20-first-mission-wait-cta-text-dev-steps.md

   크기는 추정이 아니라 **원본 서체 실측**이다. Figma 가 보고한 박스 폭과 자폭이 일치한다:
     GosanjaOTF 69px  \`자, 이제 모험을 시작해 볼까?\`  → 870.7 vs 871 (1.000)
     Pretendard SB 48px \`리더기에 QR코드를 스캔하세요.\` → 599.4 vs 600 (0.999)

   🔴 두 줄 모두 **고정 박스 대신 전체 폭 중앙정렬**이다. 디자인 박스(871/600)의 중심이
      곧 화면 중심(960.5 / 960)이라 결과가 같으면서, 대체 서체가 넓거나 좁아져도
      중심이 흔들리지 않는다. \`nowrap\` 은 디자인 지정이자 줄바꿈 방지 안전판이다. */
.qt-page-first-mission .qt-first-mission-cta-title {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(724 * var(--fm-u));
  margin: 0;
  color: #fff3db;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: calc(69 * var(--fm-u));
  font-weight: 400;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

/* 🔴 안내 줄은 **디자인 서체(Pretendard SemiBold)를 그대로 쓴다** — 위 @font-face 참조.
   그래서 크기 보정이 없다: 디자인값 48px 그대로다(실측 자폭 599.4 vs 디자인 600).
   여기에 GosanjaOTF 를 넣으면 같은 px 에서 11% 넓어지므로(실측 666.7) 서체를 바꾸려면
   크기 보정이 함께 와야 한다 — 바꾸지 말 것. */
.qt-page-first-mission .qt-first-mission-cta-sub {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(848 * var(--fm-u));
  margin: 0;
  color: #fff3db;
  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;
  font-size: calc(48 * var(--fm-u));
  font-weight: 600;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

.qt-page-first-mission .qt-first-mission-cta-em {
  color: #16cf16;
  font-style: normal;
}

.qt-page-first-mission .qt-scan-state {
  width: 100%;
  max-width: none;
  height: 100%;
  gap: 0;
  transform: none;
}

.qt-page-first-mission .qt-scanner-area {
  width: 100%;
  min-width: 0;
  min-height: 100%;
  height: 100%;
  background: #000;
  border-radius: 0;
}

/* 첫 미션 인트로와 OX 퀴즈 선행 영상의 공통 전체화면 플레이어. */
.qt-page-first-mission .qt-first-mission-intro,
.qt-page-quiz .qt-first-mission-intro {
  position: absolute;
  inset: 0;
  z-index: 20;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  background: #000;
}

.qt-page-first-mission .qt-first-mission-video,
.qt-page-quiz .qt-first-mission-video {
  display: block;
  width: 100%;
  height: 100%;
  border: 0;
  object-fit: cover;
  /* Android WebView의 autoplay 시작 전 네이티브 플레이 아이콘까지 함께 숨긴다.
     display:none은 자동 재생을 막을 수 있으므로 영상은 배치한 채 투명하게 대기한다. */
  opacity: 0;
}

.qt-page-first-mission .qt-first-mission-video-playing,
.qt-page-quiz .qt-first-mission-video-playing {
  opacity: 1;
}

/* WebKit이 controls 속성 없이도 잠깐 생성하는 시작/중앙 재생 오버레이 방어. */
.qt-page-first-mission .qt-first-mission-video::-webkit-media-controls-start-playback-button,
.qt-page-quiz .qt-first-mission-video::-webkit-media-controls-start-playback-button {
  display: none !important;
  opacity: 0;
  pointer-events: none;
  -webkit-appearance: none;
}

.qt-page-first-mission .qt-first-mission-video::-webkit-media-controls-overlay-play-button,
.qt-page-quiz .qt-first-mission-video::-webkit-media-controls-overlay-play-button {
  display: none !important;
  opacity: 0;
  pointer-events: none;
  -webkit-appearance: none;
}

/* 전부 완료 화면 — Figma 3698:70384 (2026-08-19 신규, 분기 3).
   원본 1920x1200: 타이틀 1000x442 @ (460,240) / 문구 983x240 @ (469,753) 86px lh1.4 #fff4d8.
   🔴 배경은 검정이다. 좌표는 절대배치로 잡고 transform 을 쓰지 않는다(저장소 관례). */
.qt-page-first-mission .qt-first-mission-complete {
  position: absolute;
  inset: 0;
  background: #000;
  z-index: 3;
}

.qt-page-first-mission .qt-first-mission-complete-title {
  position: absolute;
  left: calc(460 * var(--fm-u));
  top: calc(240 * var(--fm-u));
  width: calc(1000 * var(--fm-u));
  height: calc(442 * var(--fm-u));
  object-fit: contain;
}

.qt-page-first-mission .qt-first-mission-complete-text {
  position: absolute;
  left: calc(469 * var(--fm-u));
  top: calc(753 * var(--fm-u));
  width: calc(983 * var(--fm-u));
  margin: 0;
  color: #fff4d8;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;
  font-size: calc(86 * var(--fm-u));
  font-weight: 400;
  line-height: 1.4;
  text-align: center;
  word-break: keep-all;
}

/* ══ 인사 화면 — Figma \`3955:51667\` (2026-08-20 전면 개편) ══
   이전(3698:70357): \`반가워!\` 126px + \`견습 주키퍼 {이름} 요원\` 86px, flex 세로중앙 + gap 24.
   지금: 절대좌표 5요소 — 잎2 + \`어서와!\` + 본문 2행(이름 강조 80px) + ZOO CAMP 세로 마크.

   원본 1920x1200, 글자색 \`#fff4d8\` (⚠️ QR 대기화면의 \`#fff3db\` 와 다르다).

   🔴 **좌표는 추정이 아니라 Figma 렌더 PNG 의 잉크 밴드 실측이다.**
      측정법 대조군: 마크 밴드 678~949(높이 272)가 metadata \`y=678 h=272\` 와 정확히 일치.
      예측↔실측 — \`어서와!\` 265.7 vs 265 / 1행 432.8·516.0 vs 433·515 / 2행 549.0·602.0 vs 549·601.
      \`어서와!\` 잉크폭도 406 = Figma 텍스트 폭 406 (서체가 같으니 보정 없음).

   🔴 **2행 top 529.6 은 오타가 아니다.** Figma 는 행간을 *베이스라인 간격*(52x1.8=93.6)으로
      잡고 CSS 는 행상자를 쌓는다. CSS 로 그냥 쌓으면 베이스라인 간격이 111.9 가 되어 2행이
      디자인보다 **18.4px 아래**로 내려간다. 그래서 2행을 절대좌표로 따로 놓는다.
      1행 상자(404~548)와 2행 상자(529.6~623.2)는 18.4px 겹치지만 **잉크는 안 겹친다**(516<549).

   🔴 transform 을 쓰지 않는다(저장소 관례, 2026-07-31 사고). 가로 중앙은 전체 폭 +
      \`text-align:center\` 로 잡아 이름 길이가 변해도 중심이 유지되게 한다. */
.qt-page-first-mission .qt-first-mission-greeting {
  position: absolute;
  inset: 0;
  margin: 0;
  color: #fff4d8;
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;
  font-weight: 400;
  word-break: keep-all;
}

.qt-page-first-mission .qt-first-mission-greeting-hello {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(250 * var(--fm-u));
  margin: 0;
  color: #fff4d8;
  font-size: calc(126 * var(--fm-u));
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
}

.qt-page-first-mission .qt-first-mission-greeting-line1 {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(404 * var(--fm-u));
  margin: 0;
  font-size: calc(52 * var(--fm-u));
  line-height: calc(144 * var(--fm-u));
  text-align: center;
  white-space: nowrap;
}

.qt-page-first-mission .qt-first-mission-greeting-line2 {
  position: absolute;
  left: 0;
  right: 0;
  top: calc(529.6 * var(--fm-u));
  margin: 0;
  font-size: calc(52 * var(--fm-u));
  line-height: calc(93.6 * var(--fm-u));
  text-align: center;
  white-space: nowrap;
}

.qt-page-first-mission .qt-first-mission-greeting-name {
  color: #07dc00;
  font-size: calc(80 * var(--fm-u));
  font-style: normal;
}

.qt-page-first-mission .qt-first-mission-greeting-leaf-left {
  position: absolute;
  left: calc(656 * var(--fm-u));
  top: calc(277 * var(--fm-u));
  width: calc(71 * var(--fm-u));
  height: calc(77 * var(--fm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_1___}) no-repeat center / contain;
  pointer-events: none;
}

.qt-page-first-mission .qt-first-mission-greeting-leaf-right {
  position: absolute;
  left: calc(1194 * var(--fm-u));
  top: calc(278 * var(--fm-u));
  width: calc(71 * var(--fm-u));
  height: calc(76 * var(--fm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_2___}) no-repeat center / contain;
  pointer-events: none;
}

.qt-page-first-mission .qt-first-mission-greeting-mark {
  position: absolute;
  left: calc(870.5 * var(--fm-u));
  top: calc(678 * var(--fm-u));
  width: calc(180 * var(--fm-u));
  height: calc(272 * var(--fm-u));
  background: url(${___CSS_LOADER_URL_REPLACEMENT_3___}) no-repeat center / contain;
  pointer-events: none;
}

/* HTTP(카메라 차단)일 때 카메라 대신 띄우는 USB 리더기 안내 — 어두운 박스 위 흰 글자. */
.qt-page .qt-usb-prompt {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 14px;
  padding: 24px;
  color: #fff;
  text-align: center;
}
/* 단순 태깅(qr) 화면의 미션 이름 — 아이콘 위에 놓는다(2026-07-30 요청).
   이 화면은 안내판이 없어 운영자가 어떤 미션인지 알 수 없었다.

   🔴 **한 줄 고정**(2026-07-30 재요청). 처음엔 \`max-width: 90%\` 로 두 줄을 허용했는데,
      부모(.qt-usb-prompt)가 **내용에 맞춰 줄어드는 flex 아이템**이라 그 90% 가 짧은
      "QR 스캔" 글자 폭 기준이 돼 이름이 접혔다. \`nowrap\` 은 부모를 이름 폭까지 넓히므로
      이 문제가 함께 사라진다.
   실측(2026-07-30): active 스팟명 최대 10자·평균 5.96자 → 32px 로 약 340px, 스캔 영역
      최소 폭 420px 안에 한 줄로 들어간다. ellipsis 는 훗날 아주 긴 이름이 들어와도
      레이아웃이 깨지지 않게 두는 **안전망**이며 통상 경로에서는 작동하지 않는다. */
.qt-page .qt-usb-mission {
  margin: 0;
  max-width: 90vw;
  font-size: 32px;
  font-weight: 800;
  line-height: 1.3;
  text-align: center;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  /* 어두운 스캔 박스 위 흰 글씨 — 밝은 배경이 비쳐도 읽히게 그림자를 준다. */
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

.qt-page .qt-usb-icon {
  font-size: 64px;
}
.qt-page .qt-usb-text {
  margin: 0;
  font-size: 24px;
  font-weight: 700;
  line-height: 1.4;
}

/* (HTTPS 등 카메라 동작 환경) 카메라 안내(dev-notice) override — 어두운 박스 가독성. */
.qt-page .qr-scanner-dev-notice p {
  font-size: 18px;
  color: #fff;
}

.qt-page .qt-overlay {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 12px;
  border-radius: 16px;
  z-index: 5;
}

.qt-page .qt-overlay-busy {
  background: rgba(6, 78, 59, 0.78);
  color: #fff;
  font-size: 20px;
  font-weight: 700;
}

.qt-page .qt-overlay-success {
  background: rgba(5, 150, 105, 0.95);
  color: #fff;
  animation: qt-pop 0.25s ease-out;
}

.qt-page .qt-overlay-fail {
  background: rgba(185, 28, 28, 0.94);
  color: #fff;
  animation: qt-shake 0.3s ease-in-out;
}

/* 전체완료(D9 ③) 팝업 강조 — 메시지를 더 크게/도드라지게 */
.qt-page .qt-overlay-popup {
  background: rgba(4, 120, 87, 0.97);
}

.qt-page .qt-overlay-popup .qt-feedback-msg {
  font-size: 44px;
}

.qt-page .qt-feedback-msg {
  margin: 0;
  padding: 0 20px;
  font-size: 34px;
  font-weight: 800;
  text-align: center;
  line-height: 1.3;
}

.qt-page .qt-spinner {
  width: 48px;
  height: 48px;
  border: 5px solid rgba(255, 255, 255, 0.3);
  border-top-color: #fff;
  border-radius: 50%;
  animation: qt-spin 0.8s linear infinite;
}

@keyframes qt-spin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes qt-pop {
  0% {
    transform: scale(0.85);
    opacity: 0;
  }
  100% {
    transform: scale(1);
    opacity: 1;
  }
}

@keyframes qt-shake {
  0%, 100% {
    transform: translateX(0);
  }
  25% {
    transform: translateX(-8px);
  }
  75% {
    transform: translateX(8px);
  }
}

/* ══ 카메라(funny_photo) 스캔 대기 안내판 — Figma 2255:66132 ══
   원본 프레임 1920x1200(정글에 매달린 간판 + zoolung mission 로고).
   모든 치수를 "Figma 1px" 단위(--cam-u)로 환산해 쓰므로 해상도가 달라도 비율이 유지된다
   (px 고정 시 1280x800 에서 넘침).

   --cam-u : Figma 1px = 100vw / 1920.  손잡이는 이것 **하나뿐**이다.
             옛 \`--cam-scale\`·\`--cam-stretch\` 는 대체 폰트(Katuri)로 디자인을 흉내 내던
             보정이었고, 원본 폰트(GosanjaOTF)를 쓰면서 사라졌다.

   콘텐츠 프레임(2255:66152): (367.5, 332) 1184x588, 세로 flex, gap 40.
     제목 120px #189018 / 점선 / 본문 54px #005400 / 점선 / CTA 48px #005400·#ff5816
     간격 검산: 156+40 → 196+40 → 236(+210)446+40 → 486+40 → 526(+62) = 588 ✅
     중심: x 959.5 ≈ 화면중심 960 / y 626 = 화면중심보다 26px 아래 → translateY(26u) */

@font-face {
  font-family: 'Katuri';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_4___}) format('opentype');
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

/* 🔴 **이 파일이 쓰는 폰트는 이 파일이 선언한다.**
   지금까지 이 CSS 는 GosanjaOTF 를 쓰면서 선언은 다른 파일(MissionNoticeBoard.css 등)에
   기대고 있었다 — 같은 번들에 함께 로드돼 우연히 동작했을 뿐이다. 그 파일들이 이 화면에서
   빠지는 순간 폰트가 조용히 Katuri 로 폴백된다(2026-08-14 하네스 렌더에서 실제로 그렇게 됐고
   CTA 픽셀 차이 69.94 로 드러났다). 변수 스코프와 같은 원리다 — 쓰는 자리에서 선언한다.
   src 가 같으므로 브라우저가 중복 로드하지 않는다.
   출처: 국토지리정보원 X 산돌 「고산자」 (상업이용·웹폰트 임베딩 허용). */
@font-face {
  font-family: 'GosanjaOTF';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_5___}) format('opentype');
  font-weight: 400;
  font-display: swap;
}

/* 🔴 디자인 지정 서체 — Figma \`3951:51053\` 이 \`Pretendard Variable:SemiBold\` 를 쓴다.
   **부분집합(subset) 파일이다**: 한글 음절 전체(U+AC00-D7A3) + 한글 자모 + ASCII 만 남겨
   원본 1,548KB → 660KB 로 줄였다. 한글 전체를 담았으므로 문구를 바꿔도 tofu 가 나지 않는다.
   (같은 화면이 이미 GosanjaOTF 9,972KB 를 받으므로 추가 부담은 그 6.6% 다.)

   왜 대체 폰트로 두지 않았나 — 실측 때문이다. 같은 48px 에서 \`스캔\` 을 그리면
     Pretendard SemiBold : 자폭 83 / **글자 실제 높이 43**
     기본 스택(대체)     : 자폭 72 / **글자 실제 높이 34**  ← 0.79배
   자폭만 좁은 게 아니라 **글자 자체가 21% 작게** 그려져 "이 링크처럼" 이 성립하지 않는다.
   Gosanja 로 대신 그리는 선택지도 있었으나 같은 48px 에서 자폭 666.7(디자인 600)로
   반대로 11% 커진다 — 두 줄의 서체 대비도 사라진다.

   출처: Pretendard (SIL Open Font License 1.1) — \`LICENSE.txt\` 동봉. */
@font-face {
  font-family: 'Pretendard';
  src: url(${___CSS_LOADER_URL_REPLACEMENT_6___}) format('woff2');
  font-style: normal;
  font-weight: 600;
  font-display: swap;
}

/* 배경 교체 — 이 화면에서만. 다른 퀘스트 화면은 기존 숲 배경 유지.
   .qt-page 와 특정도가 같으므로 이 규칙이 뒤에 와야 이긴다(순서 의존).

   ⚠️ background-size 를 cover 로 두면 안 된다: 안내판 원본이 16:10(1920x1200)이라
      3:2 태블릿(1920x1280)에서 1.0667배로 확대되고 좌우 128px 이 잘려 나간다
      (나무 테두리·잎 장식이 화면 밖으로 밀림 = "확대된 느낌"의 원인).
      이 그림은 테두리 장식이 있는 판때기라 '잘림'이 '약간의 종횡비 변형'보다 훨씬 눈에 띈다.
      → 100% 100% 로 채워 잘림을 없앤다. */
/* 🔴 배율 보정이 사라진 이유 (2026-08-07, Figma 2255:66132)
   예전에는 디자인 폰트(GosanjaOTF) 대신 대체 폰트(Katuri)로 그리면서 크기를 부풀리고
   \`scaleX(1.15)\` 로 가로를 늘리는 보정을 썼다. 그런데 **디자인 원본 폰트가 이미 프로젝트에
   있다**(\`assets/fonts/gosanja/GosanjaOTF.otf\` — 안내판이 쓰고 App.js 가 선행 로드).
   원본 폰트를 쓰면 디자인 수치를 1:1 로 적용할 수 있어 보정 자체가 필요 없다.
   → \`--cam-u\` = 디자인 1px. 1920 화면에서 1px, 1280 화면에서 0.667px. */
.qt-page-cam {
  background: #101b12;
}

/* 안내판이 화면 끝까지 이어지도록 본문 여백 제거(숲 배경이 테두리로 비치는 것 방지) */
.qt-page .qt-content-cam {
  padding: 0;
  align-items: stretch;
}

/* 세로 가운데 = '화면' 가운데가 되도록 헤더를 흐름에서 뺀다.
   헤더가 흐름에 남아 있으면 .qt-content 는 (100vh - 헤더높이) 만큼만 차지하고,
   그 안에서 가운데 정렬되므로 블록 중심이 화면 중심보다 (헤더높이/2) 만큼 내려간다
   (헤더 68px → 34px 아래로 치우침). 흐름에서 빼면 .qt-content 가 유일한 flex 아이템이 되어
   100vh 를 차지하고 세로 중심이 화면 중심과 일치한다.
   안내판 배경은 .qt-page 에 있으므로 헤더를 띄워도 그림은 그대로다. */
.qt-page-cam .qt-header,
.qt-page-shoot .qt-header,
.qt-page-ox .qt-header,
.qt-page-quiz .qt-header {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  z-index: 10; /* 화면을 덮는 투명한 본문이 헤더 클릭을 가로채지 않게 위로 */
}

/* ── 촬영 화면(Figma 2300:106265 / 2300:106134) ──
   배경 그림은 FunnyPhotoRunner 가 소유한다: 촬영 중(정글 액자)과 캡처 후(사진 배경)로
   러너 내부 상태에 따라 갈리므로, 페이지가 아니라 러너가 직접 전환해야 한다.
   여기서는 러너가 화면 전체를 쓰도록 레이아웃만 열어준다. */
.qt-page-shoot .qt-mission-state,
.qt-page-quiz .qt-mission-state {
  max-width: none;
  width: 100%;
  height: 100%;
  gap: 0;
}

.qt-page-shoot .qt-mission-area,
.qt-page-quiz .qt-mission-area {
  flex: 1 1;
  width: 100%;
  min-height: 0;
}

/* .qt-scan-state 의 max-width/gap/transform 을 이 화면에서는 해제 */
.qt-page .qt-cam-scan {
  position: relative;
  max-width: none;
  width: 100%;
  gap: 0;
  transform: none;
  justify-content: center;
}

/* 개정 화면의 무대 - 화면 전체를 쓴다(간판 중앙정렬이 아니라 절대좌표 배치).
   Figma 3563:43238 프레임 1920x1200 기준. */
.qt-page .qt-cam-hero-wrap {
  position: absolute;
  inset: 0;
}

/* zoolung mission 로고 - Figma (690,78) 540x270.
   기존 OX 자산을 재사용한다. 배치 역산 크롭 (178,182)-(1426,806) = 1248x624 로
   \`ox_scan_logo.webp\` 와 크기가 같고 픽셀 대조 평균 채널 차이 3.72 였다.
   주의: OX 화면은 top 38, 이 화면은 top 78 이다. */
.qt-page .qt-cam-logo {
  position: absolute;
  left: calc(690 * var(--cam-u));
  top: calc(78 * var(--cam-u));
  width: calc(540 * var(--cam-u));
  height: calc(270 * var(--cam-u));
  background: none;
}

/* 대형 타이틀 - Figma (140,430) 1640x420.
   🔴 늘려야(fill) 정상 비율이다. 원본(1024x1024)은 세로로 눌린 채 저장돼 있어
      1640x420 상자에 펴야 제 모습이 된다. contain 을 쓰면 길쭉하고 작아진다.
      피그마 코드도 object-fit 없이 size-full 이라 기본값 fill 이다. */
.qt-page .qt-cam-mission-title {
  position: absolute;
  left: calc(140 * var(--cam-u));
  top: calc(430 * var(--cam-u));
  width: calc(1640 * var(--cam-u));
  height: calc(420 * var(--cam-u));
  background: none;
}

/* 하단 안내 - Figma (373,1025) 1175x65, 50px.
   🔴 흰 테두리가 필수다. 이 글자는 정글 배경 위에 바로 얹힌다(개정 전에는 밝은 나무 안내판
      위였다). 테두리가 없으면 진초록 글자가 잎사귀에 묻혀 읽히지 않는다.
      ⚠️ get_design_context 는 텍스트 획을 CSS 로 내보내지 않는다 - 반환 코드에 stroke 가
         없다고 디자인에 없는 게 아니다. 참조 렌더를 픽셀 분석해야 한다
         (이번 실측: CTA 영역 흰색 35.3%, OX 화면 35.2% 와 사실상 동일).
      🔴 두께는 **참조 렌더 픽셀 실측**으로 정했다(비례 계산이 아니다).
         OX 비율(폰트의 9.8% = stroke 10)로 시작했더니 CTA 평균 채널 차이가 23.84 로 떴다.
         10 -> 14 -> 16 을 실제로 렌더해 대조한 결과 **16 에서 흰 테두리 세로 범위가
         (1024,1088) 로 피그마와 정확히 일치**했고 차이가 7.71 까지 떨어졌다.
         (흰 픽셀 총량 17,792 vs 참조 17,318 = 2.7% 차이는 안티에일리어싱 수준)
         ⚠️ 즉 획 두께는 폰트 크기에 단순 비례하지 않는다 - 다음 화면에서도 실측할 것.
   paint-order 로 획을 글자 뒤에 깔아 자형이 얇아지지 않게 한다. */
.qt-page .qt-cam-cta {
  position: absolute;
  left: 50%;
  top: calc(1025 * var(--cam-u));
  width: calc(1175 * var(--cam-u));
  margin: 0 0 0 calc(-587.5 * var(--cam-u));
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: calc(50 * var(--cam-u));
  line-height: 1.3;
  color: #005400;
  text-align: center;
  white-space: nowrap;
  -webkit-text-stroke: calc(16 * var(--cam-u)) #fff;
  paint-order: stroke fill;
}

.qt-page .qt-cam-cta-em {
  font-style: normal;
  color: #ff5816;
}

/* 이 화면의 오버레이는 스캔 박스가 아니라 화면 전체를 덮는다.
   헤더를 z-index:10 으로 띄웠으므로, 전체화면 메시지가 헤더까지 덮도록 그보다 위에 둔다. */
.qt-page .qt-cam-scan .qt-overlay {
  border-radius: 0;
  z-index: 20;
}

/* ══ OX 퀴즈 스캔 대기 — 정글 배경 + 대형 타이틀 (Figma 1966:43882, 2026-08-12 취득) ══
   🔴 **같은 노드가 개정됐다.** 이전(2026-07-29)은 나무 간판 + 배지 + 스팟명이었다.
      개정본은 배경 일러스트 위에 zoolung 로고 · "OX 퀴즈" 대형 텍스트 · 안내 한 줄뿐이다.
      간판/배지/점선 구조(.qt-ox-board·badge·divider)는 이때 전부 폐기했다.
   원본 프레임 1920x1200. 절대 px 을 쓰지 않고 --ox-u(vw 기준)로 잡는다 —
      이 화면은 1280x800 과 1920x1200 두 해상도를 함께 쓰기 때문이다.
   폰트는 디자인의 Tmoney RoundWind 가 저장소에 없어 보유 Katuri 로 대체한다(사용자 확정). */
.qt-page-ox {
  background: #101b12;
}

/* .qt-scan-state 의 max-width/gap/transform 해제 — 이 화면은 전체를 쓴다 */
.qt-page .qt-ox-scan {
  position: absolute;
  inset: 0;
  max-width: none;
  width: 100%;
  height: 100%;
  gap: 0;
  transform: none;
}

.qt-page .qt-ox-hero-wrap {
  position: absolute;
  inset: 0;
  display: flex;
  flex-direction: column;
  align-items: center;
}

/* zoolung mission 로고 — 상단 중앙. 원본 540x270(top 38) */
.qt-page .qt-ox-logo {
  margin-top: calc(38 * var(--ox-u));
  width: calc(540 * var(--ox-u));
  height: calc(270 * var(--ox-u));
  background: none;
  flex-shrink: 0;
}

/* 대형 타이틀 — **중앙정렬 래퍼**. 남은 공간(로고 아래 ~ CTA 위)을 먹고 그 가운데에 둔다.
   🔴 개정 2 (2026-08-12 14시, Figma 3563:43250): 400px 텍스트 → **워드마크 이미지**.
      글자 전용 선언(font-family·font-size·color·white-space)은 이때 전부 제거했다 —
      이미지가 그리므로 죽은 코드이고, 남기면 "여기 텍스트가 있나" 하고 헷갈린다. */
.qt-page .qt-ox-hero {
  flex: 1 1;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 0;
}

/* 워드마크 — 피그마 원본 프레임 1540×452 (사용자 확정 크기, 1920 기준 폭 80.2%).
   🔴 **width·height 를 둘 다 명시한다.** 한쪽만 주면 나머지가 auto 가 되어
      원본 2756px 폭으로 부풀어 화면을 넘는다.
   자산은 알파 bbox 로 타이트 크롭돼 있어(2756×809, 종횡비 3.4067 ≈ 프레임 3.4071)
      이 상자에 그대로 맞는다 — object-fit 보정이 필요 없다.
   크림색 외곽선은 아트워크 내장이라 CTA 처럼 text-stroke 를 덧대지 않는다. */
.qt-page .qt-ox-hero-img {
  width: calc(1540 * var(--ox-u));
  height: calc(452 * var(--ox-u));
  display: block;
}

/* 하단 안내 — 한 줄. 원본 41px
   🔴 **흰색 테두리가 필수다.** 이 글자는 정글 배경 **위에 바로** 얹힌다(개정 전에는 밝은
      나무 간판 위였다). 테두리가 없으면 진초록 글자가 잎사귀에 묻혀 읽히지 않는다.
      ⚠️ Figma MCP 의 \`get_design_context\` 는 **텍스트 획을 CSS 로 내보내지 않는다** —
         반환 코드에 stroke 가 없다고 디자인에 없는 게 아니다. 스크린샷을 키워서 봐야 한다
         (2026-08-12 이 항목을 그렇게 놓쳐 사용자가 지적했다).
      두께는 노드 3375:44247 스크린샷 픽셀 실측 — font-size 41px 기준 한쪽 약 4px(≈10%).
   \`paint-order: stroke fill\` 로 획을 글자 **뒤**에 깔아 자형이 얇아지지 않게 한다. */
.qt-page .qt-ox-cta {
  margin: 0 0 calc(72 * var(--ox-u));
  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;
  font-size: calc(41 * var(--ox-u));
  line-height: 1.3;
  color: #005400;
  text-align: center;
  white-space: nowrap;
  -webkit-text-stroke: calc(8 * var(--ox-u)) #fff; /* 획은 안팎으로 절반씩 → 실효 4px */
  paint-order: stroke fill;
}

.qt-page .qt-ox-cta-em {
  font-style: normal;
  color: #ff5816;
}

/* 이 화면의 오버레이는 스캔 박스가 아니라 화면 전체를 덮는다 */
.qt-page .qt-ox-scan .qt-overlay {
  border-radius: 0;
  z-index: 20;
}

/* ══ 그림퀴즈 QR 대기 — OX 퀴즈와 동일한 1920×1200 레이아웃 ══ */
.qt-page-picture-quiz-scan {
  background: #101b12;
}

.qt-page .qt-picture-scan {
  position: absolute;
  inset: 0;
  max-width: none;
  width: 100%;
  height: 100%;
  gap: 0;
  transform: none;
}

.qt-page .qt-picture-hero-img {
  width: calc(1372 * var(--ox-u));
  height: calc(420 * var(--ox-u));
  display: block;
  object-fit: contain;
}

.qt-page .qt-picture-scan .qt-overlay {
  border-radius: 0;
  z-index: 20;
}

/* CRM 미션별 대기화면 — 태블릿 전체를 한 장으로 채운다. 저장 이미지가 없거나 로드에
   실패하면 JSX가 기존 Camera/OX/Picture 기본 보드로 폴백하므로 별도 오류 UI는 만들지 않는다. */
.qt-page .qt-custom-waiting-screen {
  position: absolute;
  inset: 0;
  width: 100%;
  height: 100%;
  display: block;
  object-fit: cover;
}

.qt-page .qt-waiting-screen-error {
  position: absolute;
  inset: 0;
  display: grid;
  place-items: center;
  padding: 32px;
  color: #fff;
  background: #101b12;
  font-size: clamp(24px, 3vw, 48px);
  text-align: center;
}


/* ══ 헤더 알파 처리 — 배경 일러스트가 비치도록 ══
   ⚠️ 중앙 요소에만 알파를 주면 그 뒤의 초록 띠(qt-header 그라데이션)가 비칠 뿐이라
      "배경이 비친다"가 성립하지 않는다. 그래서 띠 자체를 걷고,
      요구된 3요소(퀘스트 미션 / 퀴즈 이름 / 지점 이름)를 담은 .qt-header-center 에 알파를 준다.
   '← 메뉴' 는 요구 대상이 아니고 조작 버튼이라 알파를 주지 않는다(자체 흰 알약으로 식별 유지). */
.qt-page .qt-header {
  background: transparent;
}

.qt-page .qt-header-center {
  opacity: 0.55;
  /* 알파를 줘도 밝은 배경 위에서 글자 형태가 사라지지 않도록 최소한의 윤곽 */
  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);
}

/* ══ OX 퀴즈 문항 화면 배경 (Figma 1966:43897) ══
   \`mission_camera_*.webp\`(평평한 나무판)를 쓴다.
   ⚠️ 2026-08-07 정정 — 이 파일은 원래 "카메라 안내판(2300:106404)과 동일해서 공유한다" 였으나,
      카메라 안내판이 2255:66132(정글에 매달린 간판)로 바뀌면서 **공유 관계가 끝났다.**
      이제 \`mission_camera_*.webp\` 는 OX 문항 화면 **전용**이다 — 지우면 안 된다. */
/* 배경 그림은 OxQuizRunner 가 소유한다 — 문항 화면(나무판)과 마무리 화면(숲)이
   러너 내부 상태로 갈리므로, 페이지가 아니라 러너가 직접 전환해야 한다.
   여기서는 러너가 화면 전체를 쓰도록 레이아웃만 열어준다(위 .qt-page-quiz .qt-mission-* 규칙). */
`, "",{"version":3,"sources":["webpack://./src/pages/QuestTagPage.css"],"names":[],"mappings":"AAAA;;;;EAIE;;AAEF;EACE,YAAY;EACZ,aAAa;EACb,aAAa;EACb,sBAAsB;EACtB,yBAAyB;EACzB,mHAAmH;EACnH,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE;IACE,oHAAoH;EACtH;AACF;;AAEA,aAAa;AACb;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;EAClB,4FAA4F;EAC5F,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,qCAAqC;EACrC,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,sBAAsB;EACtB,YAAY;EACZ,aAAa;EACb,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,0CAA0C;EAC1C,kBAAkB;EAClB,cAAc;EACd,qCAAqC;EACrC,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,eAAe;EACf,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;AACzB;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,WAAW,EAAE,+BAA+B;AAC9C;;AAEA;EACE,eAAe;EACf,aAAa;AACf;;AAEA,gBAAgB;AAChB;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,cAAc;AAChB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,iBAAiB;EACjB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,8DAA8D;AAChE;;AAEA;EACE,sBAAsB;EACtB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;AAChD;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,eAAe;AACjB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA,sBAAsB;AACtB;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;EAC9B,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;EACT,cAAc;EACd,YAAY;AACd;;AAEA,uCAAuC;AACvC;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA,gBAAgB;AAChB;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,4BAA4B;AAC9B;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB;gDAC8C;EAC9C,gBAAgB;EAChB,WAAW;EACX;wDACsD;EACtD,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE;IACE,UAAU;IACV,gBAAgB;EAClB;AACF;;AAEA;;uCAEuC;AACvC;EACE;;yDAEuD;EACvD,aAAa,EAAE,4BAA4B;EAC3C,4CAA4C,EAAE,cAAc;;EAE5D,sBAAsB;EACtB,sBAAsB;EACtB,WAAW;AACb;;AAEA;;;;;;;8CAO8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,qCAAqC;EACrC,8EAA4F;EAC5F,oBAAoB;AACtB;;AAEA;;;;;;;;;uDASuD;AACvD;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,SAAS;EACT,cAAc;EACd,kFAAkF;EAClF,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;;;+BAG+B;AAC/B;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,SAAS;EACT,cAAc;EACd,4FAA4F;EAC5F,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,eAAe;EACf,YAAY;EACZ,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,yCAAyC;AACzC;;EAEE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;;EAEE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,SAAS;EACT,iBAAiB;EACjB;0DACwD;EACxD,UAAU;AACZ;;AAEA;;EAEE,UAAU;AACZ;;AAEA,sDAAsD;AACtD;;EAEE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;EAEE,wBAAwB;EACxB,UAAU;EACV,oBAAoB;EACpB,wBAAwB;AAC1B;;AAEA;;0DAE0D;AAC1D;EACE,kBAAkB;EAClB,QAAQ;EACR,gBAAgB;EAChB,UAAU;AACZ;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,+BAA+B;EAC/B,+BAA+B;EAC/B,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,8BAA8B;EAC9B,SAAS;EACT,cAAc;EACd,kFAAkF;EAClF,iCAAiC;EACjC,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;;;;;;;;;;;;;;;;;wDAiBwD;AACxD;EACE,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,cAAc;EACd,kFAAkF;EAClF,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,SAAS;EACT,cAAc;EACd,kCAAkC;EAClC,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,4BAA4B;EAC5B,SAAS;EACT,iCAAiC;EACjC,oCAAoC;EACpC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,OAAO;EACP,QAAQ;EACR,8BAA8B;EAC9B,SAAS;EACT,iCAAiC;EACjC,qCAAqC;EACrC,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iCAAiC;EACjC,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,6BAA6B;EAC7B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8EAAkG;EAClG,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,6BAA6B;EAC7B,8BAA8B;EAC9B,8EAAmG;EACnG,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,+BAA+B;EAC/B,4BAA4B;EAC5B,8BAA8B;EAC9B,+BAA+B;EAC/B,8EAAgG;EAChG,oBAAoB;AACtB;;AAEA,2DAA2D;AAC3D;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;AACA;;;;;;;;;oDASoD;AACpD;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,+CAA+C;EAC/C,0CAA0C;AAC5C;;AAEA;EACE,eAAe;AACjB;AACA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,kEAAkE;AAClE;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,mBAAmB;EACnB,UAAU;AACZ;;AAEA;EACE,iCAAiC;EACjC,WAAW;EACX,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,gCAAgC;AAClC;;AAEA;EACE,mCAAmC;EACnC,WAAW;EACX,oCAAoC;AACtC;;AAEA,uCAAuC;AACvC;EACE,kCAAkC;AACpC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,eAAe;EACf,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,0CAA0C;EAC1C,sBAAsB;EACtB,kBAAkB;EAClB,uCAAuC;AACzC;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,UAAU;EACZ;EACA;IACE,mBAAmB;IACnB,UAAU;EACZ;AACF;;AAEA;EACE;IACE,wBAAwB;EAC1B;EACA;IACE,2BAA2B;EAC7B;EACA;IACE,0BAA0B;EAC5B;AACF;;AAEA;;;;;;;;;;;;wEAYwE;;AAExE;EACE,qBAAqB;EACrB,+DAAuE;EACvE,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;8CAM8C;AAC9C;EACE,yBAAyB;EACzB,+DAAqE;EACrE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;;;;;;mEAYmE;AACnE;EACE,yBAAyB;EACzB,4DAAuF;EACvF,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;;;;;iCAOiC;AACjC;;;;;6DAK6D;AAC7D;EACE,mBAAmB;AACrB;;AAEA,oDAAoD;AACpD;EACE,UAAU;EACV,oBAAoB;AACtB;;AAEA;;;;;8CAK8C;AAC9C;;;;EAIE,kBAAkB;EAClB,MAAM;EACN,OAAO;EACP,QAAQ;EACR,WAAW,EAAE,qCAAqC;AACpD;;AAEA;;;oCAGoC;AACpC;;EAEE,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;AACR;;AAEA;;EAEE,SAAO;EACP,WAAW;EACX,aAAa;AACf;;AAEA,0DAA0D;AAC1D;EACE,kBAAkB;EAClB,eAAe;EACf,WAAW;EACX,MAAM;EACN,eAAe;EACf,uBAAuB;AACzB;;AAEA;uCACuC;AACvC;EACE,kBAAkB;EAClB,QAAQ;AACV;;AAEA;;;wCAGwC;AACxC;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,4BAA4B;EAC5B,+BAA+B;EAC/B,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;uDAGuD;AACvD;EACE,kBAAkB;EAClB,8BAA8B;EAC9B,6BAA6B;EAC7B,gCAAgC;EAChC,gCAAgC;EAChC,gBAAgB;AAClB;;AAEA;;;;;;;;;;;;8CAY8C;AAC9C;EACE,kBAAkB;EAClB,SAAS;EACT,8BAA8B;EAC9B,gCAAgC;EAChC,yCAAyC;EACzC,8FAA8F;EAC9F,kCAAkC;EAClC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,iDAAiD;EACjD,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA;2DAC2D;AAC3D;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;;;;;;kEAMkE;AAClE;EACE,mBAAmB;AACrB;;AAEA,+DAA+D;AAC/D;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA,mDAAmD;AACnD;EACE,kCAAkC;EAClC,8BAA8B;EAC9B,+BAA+B;EAC/B,gBAAgB;EAChB,cAAc;AAChB;;AAEA;;;oDAGoD;AACpD;EACE,SAAO;EACP,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;AACX;;AAEA;;;;;qDAKqD;AACrD;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;AAChB;;AAEA;;;;;;;iEAOiE;AACjE;EACE,kCAAkC;EAClC,8FAA8F;EAC9F,iCAAiC;EACjC,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,mBAAmB;EACnB,+CAA+C,EAAE,yBAAyB;EAC1E,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,cAAc;AAChB;;AAEA,sCAAsC;AACtC;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA,iDAAiD;AACjD;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,eAAe;EACf,WAAW;EACX,YAAY;EACZ,MAAM;EACN,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,+BAA+B;EAC/B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;mEACmE;AACnE;EACE,kBAAkB;EAClB,QAAQ;EACR,WAAW;EACX,YAAY;EACZ,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,aAAa;EACb,mBAAmB;EACnB,aAAa;EACb,WAAW;EACX,mBAAmB;EACnB,iCAAiC;EACjC,kBAAkB;AACpB;;;AAGA;;;;6DAI6D;AAC7D;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,6CAA6C;EAC7C,0CAA0C;AAC5C;;AAEA;;;;kEAIkE;AAClE;;sEAEsE","sourcesContent":["/**\n * 퀘스트 스팟 태블릿 스타일 — 가로 태블릿(landscape) 가정.\n * 주렁주렁 세계관: 숲/생명의 나무 → 그린 계열.\n * 모든 클래스는 .qt-page 하위로 스코프해 다른 화면과 충돌 방지.\n */\n\n.qt-page {\n  width: 100vw;\n  height: 100vh;\n  display: flex;\n  flex-direction: column;\n  background-color: #ecfdf5;\n  background-image: url('https://pub-18639fa7483d49ba813c66ff73606a6f.r2.dev/cdn/mission/mission_spot_1280x800.webp');\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n  color: #064e3b;\n  overflow: hidden;\n}\n\n@media (min-width: 1600px) {\n  .qt-page {\n    background-image: url('https://pub-18639fa7483d49ba813c66ff73606a6f.r2.dev/cdn/mission/mission_spot_1920x1200.webp');\n  }\n}\n\n/* ── 헤더 ── */\n.qt-page .qt-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 12px 20px;\n  background: linear-gradient(135deg, rgba(5, 150, 105, 0.5) 0%, rgba(16, 185, 129, 0.5) 100%);\n  color: #fff;\n  flex-shrink: 0;\n}\n\n.qt-page .qt-btn-back {\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  border: none;\n  border-radius: 10px;\n  padding: 10px 16px;\n  font-size: 16px;\n  font-weight: 600;\n  cursor: pointer;\n}\n\n.qt-page .qt-btn-back:active {\n  background: rgba(255, 255, 255, 0.32);\n}\n\n.qt-page .qt-header-center {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 2px;\n  cursor: pointer;\n}\n\n.qt-page .qt-header-center h1 {\n  margin: 0;\n  font-size: 22px;\n  font-weight: 800;\n}\n\n.qt-page .qt-header-title {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 10px;\n  max-width: calc(100vw - 260px);\n}\n\n.qt-page .qt-header-spot-trigger {\n  appearance: none;\n  box-sizing: border-box;\n  height: 20px;\n  min-height: 0;\n  max-height: 20px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  max-width: 260px;\n  border: 1px solid rgba(255, 255, 255, 0.7);\n  border-radius: 8px;\n  padding: 0 8px;\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n  font-size: 16px;\n  font-weight: 800;\n  line-height: 16px;\n  cursor: pointer;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n}\n\n.qt-page .qt-header-spot-trigger:active {\n  background: rgba(255, 255, 255, 0.32);\n}\n\n.qt-page .qt-header-spot-trigger:disabled {\n  opacity: 0.62;\n  cursor: default;\n}\n\n.qt-page .qt-header-spacer {\n  width: 92px; /* btn-back 폭 대칭 → 타이틀 가운데 정렬 */\n}\n\n.qt-page .store-badge-inline {\n  font-size: 13px;\n  opacity: 0.92;\n}\n\n/* ── 본문 공통 ── */\n.qt-page .qt-content {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 20px;\n  overflow: auto;\n}\n\n/* ── 로딩/에러/세트없음 ── */\n.qt-page .qt-center-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  text-align: center;\n}\n\n.qt-page .qt-center-icon {\n  font-size: 72px;\n}\n\n.qt-page .qt-center-text {\n  margin: 0;\n  font-size: 26px;\n  font-weight: 700;\n}\n\n.qt-page .qt-center-error .qt-center-text {\n  color: #b91c1c;\n}\n\n.qt-page .qt-btn {\n  border: none;\n  border-radius: 12px;\n  font-weight: 700;\n  cursor: pointer;\n}\n\n.qt-page .qt-btn-retry {\n  background: #059669;\n  color: #fff;\n  padding: 12px 28px;\n  font-size: 18px;\n}\n\n.qt-page .qt-btn-retry:active {\n  background: #047857;\n}\n\n/* ── 스팟 선택 ── */\n.qt-page .qt-select-state {\n  width: 100%;\n  max-width: 1000px;\n  display: flex;\n  flex-direction: column;\n  gap: 24px;\n}\n\n.qt-page .qt-select-head {\n  text-align: center;\n}\n\n.qt-page .qt-select-title {\n  margin: 0 0 6px;\n  font-size: 28px;\n  font-weight: 800;\n}\n\n.qt-page .qt-select-sub {\n  margin: 0;\n  font-size: 16px;\n  color: #047857;\n}\n\n.qt-page .qt-spot-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 16px;\n}\n\n.qt-page .qt-spot-card {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding: 24px 20px;\n  background: #fff;\n  border: 2px solid #a7f3d0;\n  border-radius: 16px;\n  cursor: pointer;\n  text-align: left;\n  transition: transform 0.1s, border-color 0.1s, box-shadow 0.1s;\n}\n\n.qt-page .qt-spot-card:active {\n  transform: scale(0.98);\n  border-color: #059669;\n  box-shadow: 0 4px 16px rgba(5, 150, 105, 0.25);\n}\n\n.qt-page .qt-spot-card-selected {\n  background: #ecfdf5;\n  border-color: #059669;\n  box-shadow: 0 4px 16px rgba(5, 150, 105, 0.18);\n}\n\n.qt-page .qt-spot-name {\n  font-size: 22px;\n  font-weight: 800;\n  color: #064e3b;\n}\n\n.qt-page .qt-spot-desc {\n  font-size: 14px;\n  color: #6b7280;\n  line-height: 1.4;\n}\n\n.qt-page .qt-spot-card-foot {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 8px;\n  align-items: center;\n  margin-top: 4px;\n}\n\n/* 스팟 카드 미션 배지(qr 이외) — 운영자가 스팟 종류를 한눈에 구분 */\n.qt-page .qt-spot-mission {\n  font-size: 13px;\n  font-weight: 700;\n  color: #047857;\n  background: #d1fae5;\n  border-radius: 999px;\n  padding: 4px 12px;\n}\n\n.qt-page .qt-spot-current {\n  font-size: 13px;\n  font-weight: 800;\n  color: #fff;\n  background: #059669;\n  border-radius: 999px;\n  padding: 4px 12px;\n}\n\n/* ── 헤더 스팟 선택 팝업 ── */\n.qt-page .qt-spot-modal-backdrop {\n  position: fixed;\n  inset: 0;\n  z-index: 50;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 24px;\n  background: rgba(6, 78, 59, 0.46);\n}\n\n.qt-page .qt-spot-modal {\n  width: min(920px, 100%);\n  max-height: calc(100vh - 48px);\n  display: flex;\n  flex-direction: column;\n  gap: 18px;\n  padding: 22px;\n  background: #fff;\n  border: 2px solid #a7f3d0;\n  border-radius: 16px;\n  box-shadow: 0 24px 64px rgba(6, 78, 59, 0.28);\n}\n\n.qt-page .qt-spot-modal-head {\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 16px;\n}\n\n.qt-page .qt-spot-modal-title {\n  margin: 0 0 4px;\n  font-size: 26px;\n  font-weight: 900;\n  color: #064e3b;\n}\n\n.qt-page .qt-spot-modal-sub {\n  margin: 0;\n  font-size: 15px;\n  font-weight: 700;\n  color: #047857;\n}\n\n.qt-page .qt-spot-modal-close {\n  border: none;\n  border-radius: 10px;\n  padding: 10px 16px;\n  background: #e5e7eb;\n  color: #374151;\n  font-size: 15px;\n  font-weight: 800;\n  cursor: pointer;\n}\n\n.qt-page .qt-spot-modal-close:active {\n  background: #d1d5db;\n}\n\n.qt-page .qt-spot-modal-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));\n  gap: 14px;\n  overflow: auto;\n  padding: 2px;\n}\n\n/* ── 미션 수행 화면(ox/funny — 회원 식별 후) ── */\n.qt-page .qt-mission-state {\n  width: 100%;\n  max-width: 860px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n}\n\n.qt-page .qt-mission-area {\n  width: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  min-height: 45vh;\n}\n\n/* ── 스캔 화면 ── */\n.qt-page .qt-scan-state {\n  width: 100%;\n  max-width: 720px;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 16px;\n  transform: translateY(-24px);\n}\n\n.qt-page .qt-scanner-area {\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  /* 카메라 미동작(HTTP·USB 리더기) 시에도 영역이 붕괴되지 않게 — 컬러 오버레이가\n     항상 충분한 영역을 덮어 흰 글자가 밝은 페이지로 삐져나오지 않도록 한다. */\n  min-height: 45vh;\n  width: 100%;\n  /* 어두운 스캔 박스 — 카메라 뷰파인더 + 흰색 \"카메라 안됨\" 안내/오버레이 가독성 확보\n     (QRScanner dev-notice 가 흰색/소형이라 밝은 배경 위에선 안 보였음). */\n  background: #0b2e22;\n  border-radius: 16px;\n  overflow: hidden;\n}\n\n@media (max-width: 1599px) {\n  .qt-page .qt-scanner-area {\n    width: 60%;\n    min-width: 420px;\n  }\n}\n\n/* 관리자 `미션 선택`의 첫 번째 항목 — 장식 배경 없이 검은 화면에서 QR 태깅 대기.\n   첫 항목 판정은 QuestTagPage의 spots 배열 순서를 따르며, 이 클래스는 PHASE_SCAN에만 붙는다.\n   태깅 후 OX/사진 수행 화면은 기존 전용 배경으로 돌아간다. */\n.qt-page-first-mission {\n  /* 🔴 스케일 변수는 **쓰는 자리와 같은 규칙 트리**에서 정의한다. 조상에만 두면\n     `calc(720 * var(--fm-u))` 가 무효가 되어 요소가 브라우저 기본 크기로 쪼그라든다\n     (2026-08-13 OX 오버레이에서 실제로 겪었고 CSS 원문 가드는 그때 통과했다). */\n  --fm-scale: 1; /* 크기 조절 손잡이. 1 = Figma 원본 */\n  --fm-u: calc(100vw / 1920 * var(--fm-scale)); /* Figma 1px */\n\n  background-color: #000;\n  background-image: none;\n  color: #fff;\n}\n\n/* 첫 미션 대기 화면 로고 — Figma 3379:44765 `3956:51800`.\n   🔴 **같은 노드 id 가 세 번 바뀌었다.** 2026-08-14 BASE CAMP 720x435 →\n      2026-08-19 Z 마크 640x640(`#189018`) → 2026-08-20 **ZOO CAMP 마크 400x400**(`#00A700`).\n      재적용 전 반드시 재취득한다 — 이 화면은 그 경고가 세 번 다 맞은 사례다.\n   원본 프레임 1920x1200, 400x400 @ (760,256) → 가로만 중심(760+200=960), 세로는 top 고정.\n   🔴 **배경은 그대로 검정이다.**\n   🔴 가로 중앙정렬은 음수 마진으로 한다 — 이 저장소 관례다. transform 은 나중에 애니메이션이\n      붙으면 덮여 좌상단 기준으로 밀린다(2026-07-31 실제 사고). */\n.qt-page-first-mission .qt-first-mission-logo {\n  position: absolute;\n  left: 50%;\n  top: calc(256 * var(--fm-u));\n  width: calc(400 * var(--fm-u));\n  height: calc(400 * var(--fm-u));\n  margin-left: calc(-200 * var(--fm-u));\n  background: url('../assets/quest/first_mission_zoocamp_mark.svg') no-repeat center / contain;\n  pointer-events: none;\n}\n\n/* 첫 미션 대기 화면 CTA 문구 2행 — Figma `3939:50824` / `3951:51053` (2026-08-20 신설).\n   권위: docs/2026-08-20-first-mission-wait-cta-text-dev-steps.md\n\n   크기는 추정이 아니라 **원본 서체 실측**이다. Figma 가 보고한 박스 폭과 자폭이 일치한다:\n     GosanjaOTF 69px  `자, 이제 모험을 시작해 볼까?`  → 870.7 vs 871 (1.000)\n     Pretendard SB 48px `리더기에 QR코드를 스캔하세요.` → 599.4 vs 600 (0.999)\n\n   🔴 두 줄 모두 **고정 박스 대신 전체 폭 중앙정렬**이다. 디자인 박스(871/600)의 중심이\n      곧 화면 중심(960.5 / 960)이라 결과가 같으면서, 대체 서체가 넓거나 좁아져도\n      중심이 흔들리지 않는다. `nowrap` 은 디자인 지정이자 줄바꿈 방지 안전판이다. */\n.qt-page-first-mission .qt-first-mission-cta-title {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(724 * var(--fm-u));\n  margin: 0;\n  color: #fff3db;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: calc(69 * var(--fm-u));\n  font-weight: 400;\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n}\n\n/* 🔴 안내 줄은 **디자인 서체(Pretendard SemiBold)를 그대로 쓴다** — 위 @font-face 참조.\n   그래서 크기 보정이 없다: 디자인값 48px 그대로다(실측 자폭 599.4 vs 디자인 600).\n   여기에 GosanjaOTF 를 넣으면 같은 px 에서 11% 넓어지므로(실측 666.7) 서체를 바꾸려면\n   크기 보정이 함께 와야 한다 — 바꾸지 말 것. */\n.qt-page-first-mission .qt-first-mission-cta-sub {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(848 * var(--fm-u));\n  margin: 0;\n  color: #fff3db;\n  font-family: 'Pretendard', -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, sans-serif;\n  font-size: calc(48 * var(--fm-u));\n  font-weight: 600;\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.qt-page-first-mission .qt-first-mission-cta-em {\n  color: #16cf16;\n  font-style: normal;\n}\n\n.qt-page-first-mission .qt-scan-state {\n  width: 100%;\n  max-width: none;\n  height: 100%;\n  gap: 0;\n  transform: none;\n}\n\n.qt-page-first-mission .qt-scanner-area {\n  width: 100%;\n  min-width: 0;\n  min-height: 100%;\n  height: 100%;\n  background: #000;\n  border-radius: 0;\n}\n\n/* 첫 미션 인트로와 OX 퀴즈 선행 영상의 공통 전체화면 플레이어. */\n.qt-page-first-mission .qt-first-mission-intro,\n.qt-page-quiz .qt-first-mission-intro {\n  position: absolute;\n  inset: 0;\n  z-index: 20;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  background: #000;\n}\n\n.qt-page-first-mission .qt-first-mission-video,\n.qt-page-quiz .qt-first-mission-video {\n  display: block;\n  width: 100%;\n  height: 100%;\n  border: 0;\n  object-fit: cover;\n  /* Android WebView의 autoplay 시작 전 네이티브 플레이 아이콘까지 함께 숨긴다.\n     display:none은 자동 재생을 막을 수 있으므로 영상은 배치한 채 투명하게 대기한다. */\n  opacity: 0;\n}\n\n.qt-page-first-mission .qt-first-mission-video-playing,\n.qt-page-quiz .qt-first-mission-video-playing {\n  opacity: 1;\n}\n\n/* WebKit이 controls 속성 없이도 잠깐 생성하는 시작/중앙 재생 오버레이 방어. */\n.qt-page-first-mission .qt-first-mission-video::-webkit-media-controls-start-playback-button,\n.qt-page-quiz .qt-first-mission-video::-webkit-media-controls-start-playback-button {\n  display: none !important;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-appearance: none;\n}\n\n.qt-page-first-mission .qt-first-mission-video::-webkit-media-controls-overlay-play-button,\n.qt-page-quiz .qt-first-mission-video::-webkit-media-controls-overlay-play-button {\n  display: none !important;\n  opacity: 0;\n  pointer-events: none;\n  -webkit-appearance: none;\n}\n\n/* 전부 완료 화면 — Figma 3698:70384 (2026-08-19 신규, 분기 3).\n   원본 1920x1200: 타이틀 1000x442 @ (460,240) / 문구 983x240 @ (469,753) 86px lh1.4 #fff4d8.\n   🔴 배경은 검정이다. 좌표는 절대배치로 잡고 transform 을 쓰지 않는다(저장소 관례). */\n.qt-page-first-mission .qt-first-mission-complete {\n  position: absolute;\n  inset: 0;\n  background: #000;\n  z-index: 3;\n}\n\n.qt-page-first-mission .qt-first-mission-complete-title {\n  position: absolute;\n  left: calc(460 * var(--fm-u));\n  top: calc(240 * var(--fm-u));\n  width: calc(1000 * var(--fm-u));\n  height: calc(442 * var(--fm-u));\n  object-fit: contain;\n}\n\n.qt-page-first-mission .qt-first-mission-complete-text {\n  position: absolute;\n  left: calc(469 * var(--fm-u));\n  top: calc(753 * var(--fm-u));\n  width: calc(983 * var(--fm-u));\n  margin: 0;\n  color: #fff4d8;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-size: calc(86 * var(--fm-u));\n  font-weight: 400;\n  line-height: 1.4;\n  text-align: center;\n  word-break: keep-all;\n}\n\n/* ══ 인사 화면 — Figma `3955:51667` (2026-08-20 전면 개편) ══\n   이전(3698:70357): `반가워!` 126px + `견습 주키퍼 {이름} 요원` 86px, flex 세로중앙 + gap 24.\n   지금: 절대좌표 5요소 — 잎2 + `어서와!` + 본문 2행(이름 강조 80px) + ZOO CAMP 세로 마크.\n\n   원본 1920x1200, 글자색 `#fff4d8` (⚠️ QR 대기화면의 `#fff3db` 와 다르다).\n\n   🔴 **좌표는 추정이 아니라 Figma 렌더 PNG 의 잉크 밴드 실측이다.**\n      측정법 대조군: 마크 밴드 678~949(높이 272)가 metadata `y=678 h=272` 와 정확히 일치.\n      예측↔실측 — `어서와!` 265.7 vs 265 / 1행 432.8·516.0 vs 433·515 / 2행 549.0·602.0 vs 549·601.\n      `어서와!` 잉크폭도 406 = Figma 텍스트 폭 406 (서체가 같으니 보정 없음).\n\n   🔴 **2행 top 529.6 은 오타가 아니다.** Figma 는 행간을 *베이스라인 간격*(52x1.8=93.6)으로\n      잡고 CSS 는 행상자를 쌓는다. CSS 로 그냥 쌓으면 베이스라인 간격이 111.9 가 되어 2행이\n      디자인보다 **18.4px 아래**로 내려간다. 그래서 2행을 절대좌표로 따로 놓는다.\n      1행 상자(404~548)와 2행 상자(529.6~623.2)는 18.4px 겹치지만 **잉크는 안 겹친다**(516<549).\n\n   🔴 transform 을 쓰지 않는다(저장소 관례, 2026-07-31 사고). 가로 중앙은 전체 폭 +\n      `text-align:center` 로 잡아 이름 길이가 변해도 중심이 유지되게 한다. */\n.qt-page-first-mission .qt-first-mission-greeting {\n  position: absolute;\n  inset: 0;\n  margin: 0;\n  color: #fff4d8;\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, sans-serif;\n  font-weight: 400;\n  word-break: keep-all;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-hello {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(250 * var(--fm-u));\n  margin: 0;\n  color: #fff4d8;\n  font-size: calc(126 * var(--fm-u));\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-line1 {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(404 * var(--fm-u));\n  margin: 0;\n  font-size: calc(52 * var(--fm-u));\n  line-height: calc(144 * var(--fm-u));\n  text-align: center;\n  white-space: nowrap;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-line2 {\n  position: absolute;\n  left: 0;\n  right: 0;\n  top: calc(529.6 * var(--fm-u));\n  margin: 0;\n  font-size: calc(52 * var(--fm-u));\n  line-height: calc(93.6 * var(--fm-u));\n  text-align: center;\n  white-space: nowrap;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-name {\n  color: #07dc00;\n  font-size: calc(80 * var(--fm-u));\n  font-style: normal;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-leaf-left {\n  position: absolute;\n  left: calc(656 * var(--fm-u));\n  top: calc(277 * var(--fm-u));\n  width: calc(71 * var(--fm-u));\n  height: calc(77 * var(--fm-u));\n  background: url('../assets/quest/first_mission_greeting_leaf_left.svg') no-repeat center / contain;\n  pointer-events: none;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-leaf-right {\n  position: absolute;\n  left: calc(1194 * var(--fm-u));\n  top: calc(278 * var(--fm-u));\n  width: calc(71 * var(--fm-u));\n  height: calc(76 * var(--fm-u));\n  background: url('../assets/quest/first_mission_greeting_leaf_right.svg') no-repeat center / contain;\n  pointer-events: none;\n}\n\n.qt-page-first-mission .qt-first-mission-greeting-mark {\n  position: absolute;\n  left: calc(870.5 * var(--fm-u));\n  top: calc(678 * var(--fm-u));\n  width: calc(180 * var(--fm-u));\n  height: calc(272 * var(--fm-u));\n  background: url('../assets/quest/first_mission_greeting_zoocamp.svg') no-repeat center / contain;\n  pointer-events: none;\n}\n\n/* HTTP(카메라 차단)일 때 카메라 대신 띄우는 USB 리더기 안내 — 어두운 박스 위 흰 글자. */\n.qt-page .qt-usb-prompt {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 14px;\n  padding: 24px;\n  color: #fff;\n  text-align: center;\n}\n/* 단순 태깅(qr) 화면의 미션 이름 — 아이콘 위에 놓는다(2026-07-30 요청).\n   이 화면은 안내판이 없어 운영자가 어떤 미션인지 알 수 없었다.\n\n   🔴 **한 줄 고정**(2026-07-30 재요청). 처음엔 `max-width: 90%` 로 두 줄을 허용했는데,\n      부모(.qt-usb-prompt)가 **내용에 맞춰 줄어드는 flex 아이템**이라 그 90% 가 짧은\n      \"QR 스캔\" 글자 폭 기준이 돼 이름이 접혔다. `nowrap` 은 부모를 이름 폭까지 넓히므로\n      이 문제가 함께 사라진다.\n   실측(2026-07-30): active 스팟명 최대 10자·평균 5.96자 → 32px 로 약 340px, 스캔 영역\n      최소 폭 420px 안에 한 줄로 들어간다. ellipsis 는 훗날 아주 긴 이름이 들어와도\n      레이아웃이 깨지지 않게 두는 **안전망**이며 통상 경로에서는 작동하지 않는다. */\n.qt-page .qt-usb-mission {\n  margin: 0;\n  max-width: 90vw;\n  font-size: 32px;\n  font-weight: 800;\n  line-height: 1.3;\n  text-align: center;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  /* 어두운 스캔 박스 위 흰 글씨 — 밝은 배경이 비쳐도 읽히게 그림자를 준다. */\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);\n}\n\n.qt-page .qt-usb-icon {\n  font-size: 64px;\n}\n.qt-page .qt-usb-text {\n  margin: 0;\n  font-size: 24px;\n  font-weight: 700;\n  line-height: 1.4;\n}\n\n/* (HTTPS 등 카메라 동작 환경) 카메라 안내(dev-notice) override — 어두운 박스 가독성. */\n.qt-page .qr-scanner-dev-notice p {\n  font-size: 18px;\n  color: #fff;\n}\n\n.qt-page .qt-overlay {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 12px;\n  border-radius: 16px;\n  z-index: 5;\n}\n\n.qt-page .qt-overlay-busy {\n  background: rgba(6, 78, 59, 0.78);\n  color: #fff;\n  font-size: 20px;\n  font-weight: 700;\n}\n\n.qt-page .qt-overlay-success {\n  background: rgba(5, 150, 105, 0.95);\n  color: #fff;\n  animation: qt-pop 0.25s ease-out;\n}\n\n.qt-page .qt-overlay-fail {\n  background: rgba(185, 28, 28, 0.94);\n  color: #fff;\n  animation: qt-shake 0.3s ease-in-out;\n}\n\n/* 전체완료(D9 ③) 팝업 강조 — 메시지를 더 크게/도드라지게 */\n.qt-page .qt-overlay-popup {\n  background: rgba(4, 120, 87, 0.97);\n}\n\n.qt-page .qt-overlay-popup .qt-feedback-msg {\n  font-size: 44px;\n}\n\n.qt-page .qt-feedback-msg {\n  margin: 0;\n  padding: 0 20px;\n  font-size: 34px;\n  font-weight: 800;\n  text-align: center;\n  line-height: 1.3;\n}\n\n.qt-page .qt-spinner {\n  width: 48px;\n  height: 48px;\n  border: 5px solid rgba(255, 255, 255, 0.3);\n  border-top-color: #fff;\n  border-radius: 50%;\n  animation: qt-spin 0.8s linear infinite;\n}\n\n@keyframes qt-spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n@keyframes qt-pop {\n  0% {\n    transform: scale(0.85);\n    opacity: 0;\n  }\n  100% {\n    transform: scale(1);\n    opacity: 1;\n  }\n}\n\n@keyframes qt-shake {\n  0%, 100% {\n    transform: translateX(0);\n  }\n  25% {\n    transform: translateX(-8px);\n  }\n  75% {\n    transform: translateX(8px);\n  }\n}\n\n/* ══ 카메라(funny_photo) 스캔 대기 안내판 — Figma 2255:66132 ══\n   원본 프레임 1920x1200(정글에 매달린 간판 + zoolung mission 로고).\n   모든 치수를 \"Figma 1px\" 단위(--cam-u)로 환산해 쓰므로 해상도가 달라도 비율이 유지된다\n   (px 고정 시 1280x800 에서 넘침).\n\n   --cam-u : Figma 1px = 100vw / 1920.  손잡이는 이것 **하나뿐**이다.\n             옛 `--cam-scale`·`--cam-stretch` 는 대체 폰트(Katuri)로 디자인을 흉내 내던\n             보정이었고, 원본 폰트(GosanjaOTF)를 쓰면서 사라졌다.\n\n   콘텐츠 프레임(2255:66152): (367.5, 332) 1184x588, 세로 flex, gap 40.\n     제목 120px #189018 / 점선 / 본문 54px #005400 / 점선 / CTA 48px #005400·#ff5816\n     간격 검산: 156+40 → 196+40 → 236(+210)446+40 → 486+40 → 526(+62) = 588 ✅\n     중심: x 959.5 ≈ 화면중심 960 / y 626 = 화면중심보다 26px 아래 → translateY(26u) */\n\n@font-face {\n  font-family: 'Katuri';\n  src: url('../assets/fonts/andong-katuri/Katuri.otf') format('opentype');\n  font-style: normal;\n  font-weight: 400;\n  font-display: swap;\n}\n\n/* 🔴 **이 파일이 쓰는 폰트는 이 파일이 선언한다.**\n   지금까지 이 CSS 는 GosanjaOTF 를 쓰면서 선언은 다른 파일(MissionNoticeBoard.css 등)에\n   기대고 있었다 — 같은 번들에 함께 로드돼 우연히 동작했을 뿐이다. 그 파일들이 이 화면에서\n   빠지는 순간 폰트가 조용히 Katuri 로 폴백된다(2026-08-14 하네스 렌더에서 실제로 그렇게 됐고\n   CTA 픽셀 차이 69.94 로 드러났다). 변수 스코프와 같은 원리다 — 쓰는 자리에서 선언한다.\n   src 가 같으므로 브라우저가 중복 로드하지 않는다.\n   출처: 국토지리정보원 X 산돌 「고산자」 (상업이용·웹폰트 임베딩 허용). */\n@font-face {\n  font-family: 'GosanjaOTF';\n  src: url('../assets/fonts/gosanja/GosanjaOTF.otf') format('opentype');\n  font-weight: 400;\n  font-display: swap;\n}\n\n/* 🔴 디자인 지정 서체 — Figma `3951:51053` 이 `Pretendard Variable:SemiBold` 를 쓴다.\n   **부분집합(subset) 파일이다**: 한글 음절 전체(U+AC00-D7A3) + 한글 자모 + ASCII 만 남겨\n   원본 1,548KB → 660KB 로 줄였다. 한글 전체를 담았으므로 문구를 바꿔도 tofu 가 나지 않는다.\n   (같은 화면이 이미 GosanjaOTF 9,972KB 를 받으므로 추가 부담은 그 6.6% 다.)\n\n   왜 대체 폰트로 두지 않았나 — 실측 때문이다. 같은 48px 에서 `스캔` 을 그리면\n     Pretendard SemiBold : 자폭 83 / **글자 실제 높이 43**\n     기본 스택(대체)     : 자폭 72 / **글자 실제 높이 34**  ← 0.79배\n   자폭만 좁은 게 아니라 **글자 자체가 21% 작게** 그려져 \"이 링크처럼\" 이 성립하지 않는다.\n   Gosanja 로 대신 그리는 선택지도 있었으나 같은 48px 에서 자폭 666.7(디자인 600)로\n   반대로 11% 커진다 — 두 줄의 서체 대비도 사라진다.\n\n   출처: Pretendard (SIL Open Font License 1.1) — `LICENSE.txt` 동봉. */\n@font-face {\n  font-family: 'Pretendard';\n  src: url('../assets/fonts/pretendard/Pretendard-SemiBold.subset.woff2') format('woff2');\n  font-style: normal;\n  font-weight: 600;\n  font-display: swap;\n}\n\n/* 배경 교체 — 이 화면에서만. 다른 퀘스트 화면은 기존 숲 배경 유지.\n   .qt-page 와 특정도가 같으므로 이 규칙이 뒤에 와야 이긴다(순서 의존).\n\n   ⚠️ background-size 를 cover 로 두면 안 된다: 안내판 원본이 16:10(1920x1200)이라\n      3:2 태블릿(1920x1280)에서 1.0667배로 확대되고 좌우 128px 이 잘려 나간다\n      (나무 테두리·잎 장식이 화면 밖으로 밀림 = \"확대된 느낌\"의 원인).\n      이 그림은 테두리 장식이 있는 판때기라 '잘림'이 '약간의 종횡비 변형'보다 훨씬 눈에 띈다.\n      → 100% 100% 로 채워 잘림을 없앤다. */\n/* 🔴 배율 보정이 사라진 이유 (2026-08-07, Figma 2255:66132)\n   예전에는 디자인 폰트(GosanjaOTF) 대신 대체 폰트(Katuri)로 그리면서 크기를 부풀리고\n   `scaleX(1.15)` 로 가로를 늘리는 보정을 썼다. 그런데 **디자인 원본 폰트가 이미 프로젝트에\n   있다**(`assets/fonts/gosanja/GosanjaOTF.otf` — 안내판이 쓰고 App.js 가 선행 로드).\n   원본 폰트를 쓰면 디자인 수치를 1:1 로 적용할 수 있어 보정 자체가 필요 없다.\n   → `--cam-u` = 디자인 1px. 1920 화면에서 1px, 1280 화면에서 0.667px. */\n.qt-page-cam {\n  background: #101b12;\n}\n\n/* 안내판이 화면 끝까지 이어지도록 본문 여백 제거(숲 배경이 테두리로 비치는 것 방지) */\n.qt-page .qt-content-cam {\n  padding: 0;\n  align-items: stretch;\n}\n\n/* 세로 가운데 = '화면' 가운데가 되도록 헤더를 흐름에서 뺀다.\n   헤더가 흐름에 남아 있으면 .qt-content 는 (100vh - 헤더높이) 만큼만 차지하고,\n   그 안에서 가운데 정렬되므로 블록 중심이 화면 중심보다 (헤더높이/2) 만큼 내려간다\n   (헤더 68px → 34px 아래로 치우침). 흐름에서 빼면 .qt-content 가 유일한 flex 아이템이 되어\n   100vh 를 차지하고 세로 중심이 화면 중심과 일치한다.\n   안내판 배경은 .qt-page 에 있으므로 헤더를 띄워도 그림은 그대로다. */\n.qt-page-cam .qt-header,\n.qt-page-shoot .qt-header,\n.qt-page-ox .qt-header,\n.qt-page-quiz .qt-header {\n  position: absolute;\n  top: 0;\n  left: 0;\n  right: 0;\n  z-index: 10; /* 화면을 덮는 투명한 본문이 헤더 클릭을 가로채지 않게 위로 */\n}\n\n/* ── 촬영 화면(Figma 2300:106265 / 2300:106134) ──\n   배경 그림은 FunnyPhotoRunner 가 소유한다: 촬영 중(정글 액자)과 캡처 후(사진 배경)로\n   러너 내부 상태에 따라 갈리므로, 페이지가 아니라 러너가 직접 전환해야 한다.\n   여기서는 러너가 화면 전체를 쓰도록 레이아웃만 열어준다. */\n.qt-page-shoot .qt-mission-state,\n.qt-page-quiz .qt-mission-state {\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  gap: 0;\n}\n\n.qt-page-shoot .qt-mission-area,\n.qt-page-quiz .qt-mission-area {\n  flex: 1;\n  width: 100%;\n  min-height: 0;\n}\n\n/* .qt-scan-state 의 max-width/gap/transform 을 이 화면에서는 해제 */\n.qt-page .qt-cam-scan {\n  position: relative;\n  max-width: none;\n  width: 100%;\n  gap: 0;\n  transform: none;\n  justify-content: center;\n}\n\n/* 개정 화면의 무대 - 화면 전체를 쓴다(간판 중앙정렬이 아니라 절대좌표 배치).\n   Figma 3563:43238 프레임 1920x1200 기준. */\n.qt-page .qt-cam-hero-wrap {\n  position: absolute;\n  inset: 0;\n}\n\n/* zoolung mission 로고 - Figma (690,78) 540x270.\n   기존 OX 자산을 재사용한다. 배치 역산 크롭 (178,182)-(1426,806) = 1248x624 로\n   `ox_scan_logo.webp` 와 크기가 같고 픽셀 대조 평균 채널 차이 3.72 였다.\n   주의: OX 화면은 top 38, 이 화면은 top 78 이다. */\n.qt-page .qt-cam-logo {\n  position: absolute;\n  left: calc(690 * var(--cam-u));\n  top: calc(78 * var(--cam-u));\n  width: calc(540 * var(--cam-u));\n  height: calc(270 * var(--cam-u));\n  background: none;\n}\n\n/* 대형 타이틀 - Figma (140,430) 1640x420.\n   🔴 늘려야(fill) 정상 비율이다. 원본(1024x1024)은 세로로 눌린 채 저장돼 있어\n      1640x420 상자에 펴야 제 모습이 된다. contain 을 쓰면 길쭉하고 작아진다.\n      피그마 코드도 object-fit 없이 size-full 이라 기본값 fill 이다. */\n.qt-page .qt-cam-mission-title {\n  position: absolute;\n  left: calc(140 * var(--cam-u));\n  top: calc(430 * var(--cam-u));\n  width: calc(1640 * var(--cam-u));\n  height: calc(420 * var(--cam-u));\n  background: none;\n}\n\n/* 하단 안내 - Figma (373,1025) 1175x65, 50px.\n   🔴 흰 테두리가 필수다. 이 글자는 정글 배경 위에 바로 얹힌다(개정 전에는 밝은 나무 안내판\n      위였다). 테두리가 없으면 진초록 글자가 잎사귀에 묻혀 읽히지 않는다.\n      ⚠️ get_design_context 는 텍스트 획을 CSS 로 내보내지 않는다 - 반환 코드에 stroke 가\n         없다고 디자인에 없는 게 아니다. 참조 렌더를 픽셀 분석해야 한다\n         (이번 실측: CTA 영역 흰색 35.3%, OX 화면 35.2% 와 사실상 동일).\n      🔴 두께는 **참조 렌더 픽셀 실측**으로 정했다(비례 계산이 아니다).\n         OX 비율(폰트의 9.8% = stroke 10)로 시작했더니 CTA 평균 채널 차이가 23.84 로 떴다.\n         10 -> 14 -> 16 을 실제로 렌더해 대조한 결과 **16 에서 흰 테두리 세로 범위가\n         (1024,1088) 로 피그마와 정확히 일치**했고 차이가 7.71 까지 떨어졌다.\n         (흰 픽셀 총량 17,792 vs 참조 17,318 = 2.7% 차이는 안티에일리어싱 수준)\n         ⚠️ 즉 획 두께는 폰트 크기에 단순 비례하지 않는다 - 다음 화면에서도 실측할 것.\n   paint-order 로 획을 글자 뒤에 깔아 자형이 얇아지지 않게 한다. */\n.qt-page .qt-cam-cta {\n  position: absolute;\n  left: 50%;\n  top: calc(1025 * var(--cam-u));\n  width: calc(1175 * var(--cam-u));\n  margin: 0 0 0 calc(-587.5 * var(--cam-u));\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: calc(50 * var(--cam-u));\n  line-height: 1.3;\n  color: #005400;\n  text-align: center;\n  white-space: nowrap;\n  -webkit-text-stroke: calc(16 * var(--cam-u)) #fff;\n  paint-order: stroke fill;\n}\n\n.qt-page .qt-cam-cta-em {\n  font-style: normal;\n  color: #ff5816;\n}\n\n/* 이 화면의 오버레이는 스캔 박스가 아니라 화면 전체를 덮는다.\n   헤더를 z-index:10 으로 띄웠으므로, 전체화면 메시지가 헤더까지 덮도록 그보다 위에 둔다. */\n.qt-page .qt-cam-scan .qt-overlay {\n  border-radius: 0;\n  z-index: 20;\n}\n\n/* ══ OX 퀴즈 스캔 대기 — 정글 배경 + 대형 타이틀 (Figma 1966:43882, 2026-08-12 취득) ══\n   🔴 **같은 노드가 개정됐다.** 이전(2026-07-29)은 나무 간판 + 배지 + 스팟명이었다.\n      개정본은 배경 일러스트 위에 zoolung 로고 · \"OX 퀴즈\" 대형 텍스트 · 안내 한 줄뿐이다.\n      간판/배지/점선 구조(.qt-ox-board·badge·divider)는 이때 전부 폐기했다.\n   원본 프레임 1920x1200. 절대 px 을 쓰지 않고 --ox-u(vw 기준)로 잡는다 —\n      이 화면은 1280x800 과 1920x1200 두 해상도를 함께 쓰기 때문이다.\n   폰트는 디자인의 Tmoney RoundWind 가 저장소에 없어 보유 Katuri 로 대체한다(사용자 확정). */\n.qt-page-ox {\n  background: #101b12;\n}\n\n/* .qt-scan-state 의 max-width/gap/transform 해제 — 이 화면은 전체를 쓴다 */\n.qt-page .qt-ox-scan {\n  position: absolute;\n  inset: 0;\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  gap: 0;\n  transform: none;\n}\n\n.qt-page .qt-ox-hero-wrap {\n  position: absolute;\n  inset: 0;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n/* zoolung mission 로고 — 상단 중앙. 원본 540x270(top 38) */\n.qt-page .qt-ox-logo {\n  margin-top: calc(38 * var(--ox-u));\n  width: calc(540 * var(--ox-u));\n  height: calc(270 * var(--ox-u));\n  background: none;\n  flex-shrink: 0;\n}\n\n/* 대형 타이틀 — **중앙정렬 래퍼**. 남은 공간(로고 아래 ~ CTA 위)을 먹고 그 가운데에 둔다.\n   🔴 개정 2 (2026-08-12 14시, Figma 3563:43250): 400px 텍스트 → **워드마크 이미지**.\n      글자 전용 선언(font-family·font-size·color·white-space)은 이때 전부 제거했다 —\n      이미지가 그리므로 죽은 코드이고, 남기면 \"여기 텍스트가 있나\" 하고 헷갈린다. */\n.qt-page .qt-ox-hero {\n  flex: 1;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  margin: 0;\n}\n\n/* 워드마크 — 피그마 원본 프레임 1540×452 (사용자 확정 크기, 1920 기준 폭 80.2%).\n   🔴 **width·height 를 둘 다 명시한다.** 한쪽만 주면 나머지가 auto 가 되어\n      원본 2756px 폭으로 부풀어 화면을 넘는다.\n   자산은 알파 bbox 로 타이트 크롭돼 있어(2756×809, 종횡비 3.4067 ≈ 프레임 3.4071)\n      이 상자에 그대로 맞는다 — object-fit 보정이 필요 없다.\n   크림색 외곽선은 아트워크 내장이라 CTA 처럼 text-stroke 를 덧대지 않는다. */\n.qt-page .qt-ox-hero-img {\n  width: calc(1540 * var(--ox-u));\n  height: calc(452 * var(--ox-u));\n  display: block;\n}\n\n/* 하단 안내 — 한 줄. 원본 41px\n   🔴 **흰색 테두리가 필수다.** 이 글자는 정글 배경 **위에 바로** 얹힌다(개정 전에는 밝은\n      나무 간판 위였다). 테두리가 없으면 진초록 글자가 잎사귀에 묻혀 읽히지 않는다.\n      ⚠️ Figma MCP 의 `get_design_context` 는 **텍스트 획을 CSS 로 내보내지 않는다** —\n         반환 코드에 stroke 가 없다고 디자인에 없는 게 아니다. 스크린샷을 키워서 봐야 한다\n         (2026-08-12 이 항목을 그렇게 놓쳐 사용자가 지적했다).\n      두께는 노드 3375:44247 스크린샷 픽셀 실측 — font-size 41px 기준 한쪽 약 4px(≈10%).\n   `paint-order: stroke fill` 로 획을 글자 **뒤**에 깔아 자형이 얇아지지 않게 한다. */\n.qt-page .qt-ox-cta {\n  margin: 0 0 calc(72 * var(--ox-u));\n  font-family: 'GosanjaOTF', 'Katuri', -apple-system, BlinkMacSystemFont, 'Segoe UI', sans-serif;\n  font-size: calc(41 * var(--ox-u));\n  line-height: 1.3;\n  color: #005400;\n  text-align: center;\n  white-space: nowrap;\n  -webkit-text-stroke: calc(8 * var(--ox-u)) #fff; /* 획은 안팎으로 절반씩 → 실효 4px */\n  paint-order: stroke fill;\n}\n\n.qt-page .qt-ox-cta-em {\n  font-style: normal;\n  color: #ff5816;\n}\n\n/* 이 화면의 오버레이는 스캔 박스가 아니라 화면 전체를 덮는다 */\n.qt-page .qt-ox-scan .qt-overlay {\n  border-radius: 0;\n  z-index: 20;\n}\n\n/* ══ 그림퀴즈 QR 대기 — OX 퀴즈와 동일한 1920×1200 레이아웃 ══ */\n.qt-page-picture-quiz-scan {\n  background: #101b12;\n}\n\n.qt-page .qt-picture-scan {\n  position: absolute;\n  inset: 0;\n  max-width: none;\n  width: 100%;\n  height: 100%;\n  gap: 0;\n  transform: none;\n}\n\n.qt-page .qt-picture-hero-img {\n  width: calc(1372 * var(--ox-u));\n  height: calc(420 * var(--ox-u));\n  display: block;\n  object-fit: contain;\n}\n\n.qt-page .qt-picture-scan .qt-overlay {\n  border-radius: 0;\n  z-index: 20;\n}\n\n/* CRM 미션별 대기화면 — 태블릿 전체를 한 장으로 채운다. 저장 이미지가 없거나 로드에\n   실패하면 JSX가 기존 Camera/OX/Picture 기본 보드로 폴백하므로 별도 오류 UI는 만들지 않는다. */\n.qt-page .qt-custom-waiting-screen {\n  position: absolute;\n  inset: 0;\n  width: 100%;\n  height: 100%;\n  display: block;\n  object-fit: cover;\n}\n\n.qt-page .qt-waiting-screen-error {\n  position: absolute;\n  inset: 0;\n  display: grid;\n  place-items: center;\n  padding: 32px;\n  color: #fff;\n  background: #101b12;\n  font-size: clamp(24px, 3vw, 48px);\n  text-align: center;\n}\n\n\n/* ══ 헤더 알파 처리 — 배경 일러스트가 비치도록 ══\n   ⚠️ 중앙 요소에만 알파를 주면 그 뒤의 초록 띠(qt-header 그라데이션)가 비칠 뿐이라\n      \"배경이 비친다\"가 성립하지 않는다. 그래서 띠 자체를 걷고,\n      요구된 3요소(퀘스트 미션 / 퀴즈 이름 / 지점 이름)를 담은 .qt-header-center 에 알파를 준다.\n   '← 메뉴' 는 요구 대상이 아니고 조작 버튼이라 알파를 주지 않는다(자체 흰 알약으로 식별 유지). */\n.qt-page .qt-header {\n  background: transparent;\n}\n\n.qt-page .qt-header-center {\n  opacity: 0.55;\n  /* 알파를 줘도 밝은 배경 위에서 글자 형태가 사라지지 않도록 최소한의 윤곽 */\n  text-shadow: 0 2px 6px rgba(0, 0, 0, 0.45);\n}\n\n/* ══ OX 퀴즈 문항 화면 배경 (Figma 1966:43897) ══\n   `mission_camera_*.webp`(평평한 나무판)를 쓴다.\n   ⚠️ 2026-08-07 정정 — 이 파일은 원래 \"카메라 안내판(2300:106404)과 동일해서 공유한다\" 였으나,\n      카메라 안내판이 2255:66132(정글에 매달린 간판)로 바뀌면서 **공유 관계가 끝났다.**\n      이제 `mission_camera_*.webp` 는 OX 문항 화면 **전용**이다 — 지우면 안 된다. */\n/* 배경 그림은 OxQuizRunner 가 소유한다 — 문항 화면(나무판)과 마무리 화면(숲)이\n   러너 내부 상태로 갈리므로, 페이지가 아니라 러너가 직접 전환해야 한다.\n   여기서는 러너가 화면 전체를 쓰도록 레이아웃만 열어준다(위 .qt-page-quiz .qt-mission-* 규칙). */\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
